import React from 'react';
import { noop } from '@ajaibid/utils';
import VERIFYING_EMAIL_ACCOUNT from 'Image/verifying-email-account-popup.png';
import { bool, func } from 'prop-types';
import PopupDialog from './PopUpDialog';

const PopUpKYCReminder = ({ onActionPrimaryClick, display }) => (
  <PopupDialog
    actionPrimaryText="Mengerti"
    align="center"
    display={display}
    disabledPrimaryAction={false}
    disabledSecondaryAction={false}
    onActionPrimaryClick={onActionPrimaryClick}
    image={VERIFYING_EMAIL_ACCOUNT}
    subtitle="Untuk dapat mengakses konten halaman ini kamu perlu melakukan aktivasi akun terlebih dahulu."
    title="Ayo Aktivasi Akun Kamu!"
    variantPrimary="primary"
  />
);

PopUpKYCReminder.propTypes = {
  onActionPrimaryClick: func,
  display: bool,
};

PopUpKYCReminder.defaultProps = {
  onActionPrimaryClick: noop,
  display: true,
};

export default PopUpKYCReminder;
